import {Component} from '@angular/core';
import {ElementRef} from '@angular/core';
import {EventEmitter} from '@angular/core';
import {HostBinding} from '@angular/core';
import {HostListener} from '@angular/core';
import {Input} from '@angular/core';
import {Output} from '@angular/core';
import {ViewEncapsulation} from '@angular/core';

@Component({
    selector: 'ui-option',
    template: '<ng-content></ng-content>',
    encapsulation: ViewEncapsulation.None
})
export class UIOptionComponent {

    @Input()
    disabled: boolean;

    @Input()
    value: any;

    @HostBinding('class.selected')
    selected: boolean;

    @Output()
    onSelectOption = new EventEmitter<UIOptionComponent>();

    constructor(private _elementRef: ElementRef) {
    }

    get viewValue(): string {
        return this._elementRef.nativeElement.textContent.trim();
    }

    @HostListener('click')
    selectOption() {
        if (this.disabled === undefined) {
            this.onSelectOption.emit(this);
        }
    }

}
